import React from 'react';
import { observer } from 'mobx-react';
import QuestionIcon from '../../../../jobs/components/QuestionIcon';
import Button from '../../../../components/Button';
import styles from './PromptMessageContent.m.sass';
import Avatar from '../../../../components/Avatar';
import Icon from '../../../../components/Icon';
import { formatDateSimple } from '../../../../utils/dateUtil';
import { MessageBubble } from '../';

/**
 * Prompt Message Content
 */
export default observer(function PromptMessageContent(_ref) {
  var _prompt$question, _prompt$answeredBy, _prompt$answeredBy2;
  var prompt = _ref.prompt,
    onViewPrompt = _ref.onViewPrompt;
  var viewPrompt = React.useCallback(function (e) {
    // Prevent timestamp visibility toggle
    e.stopPropagation();
    onViewPrompt(prompt);
  }, [prompt, onViewPrompt]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, !prompt.question ? /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(PromptLoadingFailed, null)) : prompt.deleted ? /*#__PURE__*/React.createElement(MessageBubble, {
    type: "admin"
  }, "This prompt has been deleted.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardContent, {
    title: prompt.title,
    visual: /*#__PURE__*/React.createElement(QuestionIcon, {
      size: 36,
      type: (_prompt$question = prompt.question) === null || _prompt$question === void 0 ? void 0 : _prompt$question.type
    })
  }, prompt.description), /*#__PURE__*/React.createElement(CardFooter, null, !prompt.isPendingResponse && prompt.answeredBy && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardFooterItem, null, /*#__PURE__*/React.createElement(Avatar, {
    size: 36,
    checked: !prompt.isPendingResponse,
    url: prompt === null || prompt === void 0 ? void 0 : (_prompt$answeredBy = prompt.answeredBy) === null || _prompt$answeredBy === void 0 ? void 0 : _prompt$answeredBy.avatar,
    fallback: prompt === null || prompt === void 0 ? void 0 : (_prompt$answeredBy2 = prompt.answeredBy) === null || _prompt$answeredBy2 === void 0 ? void 0 : _prompt$answeredBy2.avatarFallback
  })), /*#__PURE__*/React.createElement(CardFooterItem, null, /*#__PURE__*/React.createElement(CardFooterCopy, {
    title: prompt.answeredBy.displayName
  }, formatDateSimple(prompt === null || prompt === void 0 ? void 0 : prompt.dateAnswered, {
    time: true
  })))), /*#__PURE__*/React.createElement(CardFooterSpacer, null), /*#__PURE__*/React.createElement(CardFooterItem, null, prompt.canAnswer ? /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: viewPrompt
  }, "Respond") : /*#__PURE__*/React.createElement(Button, {
    type: "translucent",
    onClick: viewPrompt
  }, "View"))))));
});

/**
 * Card
 */
export function Card(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, children);
}

/**
 * Card Content
 */
export function CardContent(_ref3) {
  var visual = _ref3.visual,
    title = _ref3.title,
    children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.cardContent
  }, visual && /*#__PURE__*/React.createElement("div", {
    className: styles.cardContentVisual
  }, visual), /*#__PURE__*/React.createElement("div", {
    className: styles.cardContentCopy
  }, title && /*#__PURE__*/React.createElement("h3", {
    className: styles.cardContentTitle
  }, title), /*#__PURE__*/React.createElement("p", {
    className: styles.cardContentBody
  }, children)));
}

/**
 * Card Footer
 */
export function CardFooter(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.cardFooter
  }, children);
}

/**
 * Card Footer Item
 */
export function CardFooterItem(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.cardFooterItem
  }, children);
}

/**
 * Card Footer Spacer
 */
export function CardFooterSpacer(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.cardFooterSpacer
  }, children);
}

/**
 * Card Footer Copy
 */
export function CardFooterCopy(_ref7) {
  var title = _ref7.title,
    children = _ref7.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.cardFooterCopy
  }, title && /*#__PURE__*/React.createElement("h6", {
    className: styles.cardFooterCopyTitle
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.cardFooterCopyBody
  }, children));
}
export function PromptLoadingFailed() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.promptLoadingFailed
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 21,
    material: true,
    name: "error outline"
  }), "\xA0 Loading prompt failed");
}
//# sourceMappingURL=index.js.map
